export function precio(importe, opciones = {}) {
  // Si no es un número, lo convertimos a string
  const localeOpts = {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  };
  if (opciones?.ajustarDecimales === false) {
    localeOpts.minimumFractionDigits = 2;
  }
  const cantidad = parseFloat(importe).toLocaleString('es', localeOpts);
  return `${cantidad} €`;
}

export function porcentaje(valor) {
  const cantidad = parseFloat(valor).toLocaleString('es', { maximumFractionDigits: 0 });
  return `${cantidad}  %`;
}
